import type { SortState } from '../../components/DataTable/types';

const allowedSortDirection = ['asc', 'desc'];

export function convertQueryToSortState(
  query: Record<string, unknown> | undefined,
  defaultValue: SortState[],
): SortState[] {
  const sortValue = query?.sort as string | string[] | undefined;

  if (!sortValue) {
    return defaultValue;
  }

  const sortValueArray = Array.isArray(sortValue) ? sortValue : [sortValue];
  const sortStateMap = sortValueArray
    .map(value => {
      const [key, direction] = value.split(',');

      if (allowedSortDirection.indexOf(direction) < 0) {
        return null;
      }

      return {
        key,
        direction,
      } as SortState;
    })
    // null 및 중복 제거
    .reduce(
      (acc, item) => {
        if (item) {
          acc[item.key] = item;
        }

        return acc;
      },
      {} as Record<string, SortState>,
    );
  const sortState = Object.values(sortStateMap);

  return sortState.length > 0 ? (sortState as SortState[]) : defaultValue;
}

/**
 * query 생성을 의도하므로, 데이터는 항상 string/string[]로 변환한다.
 * @param state
 */
export function convertSortToQueryState(state: SortState[]): Record<string, unknown> {
  if (!Array.isArray(state) || !state.length) {
    return { sort: null };
  }

  return {
    sort: state.map(({ key, direction }) => `${key},${direction}`),
  };
}
